import { Grid } from '@material-ui/core';
import React, { useState } from 'react';
import styled from 'styled-components';

import { CustomerFiltersSchema } from 'core/schemas/customerFilters';
import { FormSubmitHandler } from 'Elements/Form';

import CustomersTable from './CustomersTable';
import FilterCustomers from './FilterCustomers';

const Height100 = styled.div`
  height: 100%;
`;
const Width100 = styled.div`
  width: 100%;
  max-width: 250px;
`;
export default function CustomerList() {
  const [params, setParams] = useState();

  /**
   * @todo: use useCallback (check all others as well).
   */
  const onSubmit: FormSubmitHandler<CustomerFiltersSchema> = values => {
    setParams(serialize(values));
  };

  return (
    <Grid container direction="row" component={Height100}>
      <Grid item xs component={Width100}>
        <FilterCustomers onSubmit={onSubmit} />
      </Grid>

      <Grid item sm={12} md={8} component={Height100}>
        <CustomersTable params={params} />
      </Grid>
    </Grid>
  );
}

const serialize = (values: any): any => {
  const params = JSON.parse(JSON.stringify(values));

  return params;
};
